export default __webpack_public_path__ + "static/media/notification-project-talent.6200369f.svg";